export default __webpack_public_path__ + "static/media/Magadhi_agri2_f.61ca2969.wav";